import React from 'react';
import BlogPostTemplate from '../components/Blog/BlogPostTemplate';
import BlogMeta from '../components/Blog/BlogMeta';
import Callout from '../components/Blog/Callout';
import Figure from '../components/Blog/Figure';

function TestBlog() {
  return (
    <section className="page">
      <BlogPostTemplate
        genre="You dont need"
        title="Microservices to scale early"
        subtitle="Ship one reliable product first, then split systems when your pain points are real."
      >
        <BlogMeta
          author="Prapti Setty"
          publishedAt="May 2026"
          readTime="5 min read"
          tags={['Architecture', 'Startups', 'Backend']}
        />

        <p>
          A lot of teams hear that microservices are the mark of maturity. In practice, an early
          product usually benefits more from a simple architecture, fast iteration loops, and clear
          ownership than from service boundaries.
        </p>

        <Figure
          src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1400&q=80"
          alt="Abstract circuit board pattern representing software complexity"
          caption="Keep architecture proportional to the current product stage and team size."
        />

        <Callout tone="insight" title="Key takeaway">
          <p>Complexity is a cost. Pay for it only when it clearly returns value.</p>
        </Callout>

        <h2>Genre ideas</h2>
        <ul>
          <li>Microservices to scale early</li>
          <li>a backend for your first project</li>
          <li>AI in every product</li>
        </ul>

        <h2>When to keep a monolith</h2>
        <table>
          <thead>
            <tr>
              <th>Situation</th>
              <th>Better choice</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Small team, one product</td>
              <td>Single deployable app with clear modules</td>
            </tr>
            <tr>
              <td>Frequent product pivots</td>
              <td>Shared codebase for faster iteration</td>
            </tr>
            <tr>
              <td>No clear service boundaries yet</td>
              <td>Delay split until ownership and load patterns appear</td>
            </tr>
          </tbody>
        </table>

        <Callout tone="note" title="Use this template">
          <p>
            Duplicate this page for future posts, then update genre, title, metadata, sections, and
            media.
          </p>
        </Callout>
      </BlogPostTemplate>
    </section>
  );
}

export default TestBlog;
